import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";

import DropdownProduct from "../Dropdown/Select";
import {totalQty, totalPriceProduct, comercialQuantity, totalComercialPrice, totalPriceObraEstimativa, totalPrice, totalPriceComercial, totalPriceAlt, totalPriceComercialAlt} from '../../TableCalculations';
import TablePDF from "../../components/TablePDF/TablePDF";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  paper: {
    marginTop: 3,
    width: "100%",
    overflowX: "auto",
    marginBottom: 2
  },
  table: {
    minWidth: 650
  },
  item: {
    fontSize: "1vw"
  }
}));

export default function TemplateProducts(props) {
  const classes = useStyles();

  const [qtyObraEstimativa, setQtyObraEstimativa] = React.useState(1);
  const [obraEstimativa, setObraEstimativa] = React.useState(0);

  // function totalPrice(products, desperdicio, m2Solicitados) {
  //   let sum = 0;
  //   products.map(
  //     product =>
  //       (sum +=
  //         (product.m2qty + product.m2qty * desperdicio) *
  //         m2Solicitados *
  //         product.prod.pricem2)
  //   );
  //   return (
  //     sum + totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)
  //   ).toFixed(2);
  // }

  // function totalPriceComercial(products, desperdicio, m2Solicitados) {
  //   let sum = 0;
  //   products.map(
  //     product =>
  //       (sum +=
  //         totalComercialPrice(product.m2qty,desperdicio,m2Solicitados,product.prod.sup,product.prod.priceud) 
  //         )
  //   );
  //   return (
  //     sum + totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)
  //   ).toFixed(2);
  // }

  function handleObraEstimativaOnChange(event) {
    setObraEstimativa(event.target.value);
  }

  // function totalPriceObraEstimativa(price, quantity) {
  //   return price * quantity;
  // }

  // function totalQty(m2Qty, waste, m2get) {
  //   return (m2Qty + m2Qty * waste) * m2get;
  // }

  // function pricePerm2(m2Qty, pricem2) {
  //   return (m2Qty / pricem2);
  // }

  // function totalPriceProduct(m2Qty, waste, m2get, priceUD) {
  //   return(
  //     totalQty(m2Qty,waste,m2get) * priceUD
  //   );
  // }

  // function comercialQuantity(m2Qty, waste, m2get, sup) {
  //   return (
  //     Math.ceil(totalQty(m2Qty,waste,m2get) / sup)
  //   );
  // }

  // function totalComercialPrice(m2Qty, waste, m2get, sup, priceUD) {
  //   return (
  //     comercialQuantity(m2Qty,waste,m2get,sup) * priceUD
  //   );
  // }

  // function totalPriceAlt(products, alternativeprods, waste, m2get) {
  //   let sum = 0;

  //   products.map(
  //     product =>
  //       (sum +=
  //         (product.m2qty + product.m2qty * waste) *
  //         m2get *
  //         product.prod.pricem2) 
  //   );
          
  //   alternativeprods.map(
  //     product =>
  //       (sum +=
  //         (product.m2qty + product.m2qty * waste) *
  //         m2get *
  //         product.prod.pricem2) 
  //   );
    
  //   let sum2 = 0;

  //   alternativeprods.filter(p => p.idProductToReplace !== 0).map(
      
  //     produ => (
  //       //Hay que buscar por posicion por que si va por id despues puede no encontrarlo
  //       sum2 += (
  //         products[produ.idProductToReplace].m2qty + products[produ.idProductToReplace].m2qty * waste) *
  //         m2get *
  //         products[produ.idProductToReplace].prod.pricem2
  //         )
  //     )
    
  //   return ((sum - sum2) + totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)).toFixed(2);
  //   }

  //   function totalPriceComercialAlt(products,alternativeprods, waste, m2get) {
  //     let sum = 0;
  //     products.map(
  //       product =>
  //         (sum +=
  //           totalComercialPrice(product.m2qty,waste,m2get,product.prod.sup,product.prod.priceud) 
  //           )
  //     );

  //     alternativeprods.map(
  //       product =>
  //         (sum +=
  //           totalComercialPrice(product.m2qty,waste,m2get,product.prod.sup,product.prod.priceud) 
  //           )
  //     );

  //     let sum2 = 0;
  //     alternativeprods.filter(p => p.idProductToReplace !== 0).map(
  //         product =>
  //         (
  //           sum2 += totalComercialPrice(product.m2qty,waste,m2get,product.prod.sup,product.prod.priceud) 
  //         )
  //     )

  //     return ((sum - sum2) + totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)).toFixed(2);
  //   }

  return (
    <div>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">Unit</TableCell>
                <TableCell>Material</TableCell>
                <TableCell align="right">Cant./M2</TableCell>
                <TableCell align="right">Cant./Total</TableCell>
                <TableCell align="right">Precio(ud)</TableCell>
                <TableCell align="right">Precio(Total)</TableCell>
                <TableCell align="right">Cant. Comercial</TableCell>
                <TableCell align="right">Price(C.Com)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.products.map((product,index) => (
                <TableRow key={product.prod.id}>
                  <TableCell align="left">{product.prod.unit}</TableCell>
                  <TableCell
                    className={classes.item}
                    component="th"
                    scope="row"
                  >
                    {product.hasAlternative ? (
                      <DropdownProduct
                        position={index}
                        product={product.prod}
                        label={product.prod.description}
                        products={props.alternativeProducts.filter(
                          a =>
                            a.originalProduct.id ===
                            props.alternativeProducts.filter(
                              alt =>
                                alt.alternativeProduct.id === product.prod.id
                            )[0].originalProduct.id
                        )}
                        updtProducts={props.updateProducts}
                      />
                    ) : (
                      product.prod.description
                    )}
                  </TableCell>
                  <TableCell align="right">{product.m2qty}</TableCell>
                  <TableCell align="right">
                    {totalQty(
                      product.m2qty,
                      props.desperdicio,
                      props.m2Solicitados
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    $ {product.prod.pricem2}
                  </TableCell>
                  <TableCell align="right">
                    ${" "}
                    {
                      totalPriceProduct(product.m2qty,props.desperdicio,props.m2Solicitados,product.prod.pricem2).toFixed(2)
                      }
                  </TableCell>
                  <TableCell align="right">
                    {Math.ceil(
                      comercialQuantity(product.m2qty,props.desperdicio,props.m2Solicitados,product.prod.sup))}
                    {" " + product.prod.packaging}
                  </TableCell>
                  <TableCell align="right">
                    ${" "}
                    {
                      totalComercialPrice(product.m2qty,props.desperdicio,props.m2Solicitados,product.prod.sup,product.prod.priceud).toFixed(2)
                    }
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="left">M2</TableCell>
                <TableCell component="th" scope="row">
                  Mano de Obra Estimativa
                </TableCell>
                <TableCell align="right">-</TableCell>
                <TableCell align="right">
                  {qtyObraEstimativa.toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  <TextField error onChange={handleObraEstimativaOnChange} />
                </TableCell>
                <TableCell align="right">
                  ${" "}
                  {totalPriceObraEstimativa(
                    obraEstimativa,
                    qtyObraEstimativa
                  ).toFixed(2)}{" "}
                </TableCell>
                <TableCell align="right"> - </TableCell>
                <TableCell align="right">
                  {" "}
                  ${" "}
                  {totalPriceObraEstimativa(
                    obraEstimativa,
                    qtyObraEstimativa
                  ).toFixed(2)}{" "}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={4} />
                <TableCell>
                  <strong>TOTAL PESOS</strong>
                </TableCell>
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {totalPrice(
                    props.products,
                    props.desperdicio,
                    props.m2Solicitados,
                    obraEstimativa,
                    qtyObraEstimativa
                  )}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
                <TableCell colSpan={1} />
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {totalPriceComercial(
                    props.products,
                    props.desperdicio,
                    props.m2Solicitados,
                    obraEstimativa,
                    qtyObraEstimativa
                  )}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4} />
                <TableCell>
                  <strong>TOTAL PESOS/m2</strong>
                </TableCell>
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {(
                    totalPrice(
                      props.products,
                      props.desperdicio,
                      props.m2Solicitados,
                      obraEstimativa,
                      qtyObraEstimativa
                    ) / props.m2Solicitados
                  ).toFixed(2)}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
                <TableCell colSpan={1} />
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {(
                    totalPriceComercial(
                      props.products,
                      props.desperdicio,
                      props.m2Solicitados,
                      obraEstimativa,
                      qtyObraEstimativa
                    ) / props.m2Solicitados
                  ).toFixed(2)}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </div>
      <span>{props.altDescription}</span>                
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">Unit</TableCell>
                <TableCell>Material</TableCell>
                <TableCell align="right">Cant./M2</TableCell>
                <TableCell align="right">Cant./Total</TableCell>
                <TableCell align="right">Precio(ud)</TableCell>
                <TableCell align="right">Precio(Total)</TableCell>
                <TableCell align="right">Cant. Comercial</TableCell>
                <TableCell align="right">Price(C.Com)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {props.alternativeOption.map((product,index) => (
                <TableRow key={product.prod.id}>
                  <TableCell align="left">{product.prod.unit}</TableCell>
                  <TableCell
                    className={classes.item}
                    component="th"
                    scope="row"
                  >
                    {product.hasAlternative ? (
                      <DropdownProduct
                        position={index}
                        product={product.prod}
                        label={product.prod.description}
                        products={props.alternativeProducts.filter(
                          a =>
                            a.originalProduct.id ===
                            props.alternativeProducts.filter(
                              alt =>
                                alt.alternativeProduct.id === product.prod.id
                            )[0].originalProduct.id
                        )}
                        updtProducts={props.updateTemplateOptions}
                      />
                    ) : (
                      product.prod.description
                    )}
                  </TableCell>
                  <TableCell align="right">{product.m2qty}</TableCell>
                  <TableCell align="right">
                    {totalQty(
                      product.m2qty,
                      props.desperdicio,
                      props.m2Solicitados
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    $ {product.prod.pricem2}
                  </TableCell>
                  <TableCell align="right">
                    ${" "}
                    {
                      totalPriceProduct(product.m2qty,props.desperdicio,props.m2Solicitados,product.prod.pricem2).toFixed(2)
                      }
                  </TableCell>
                  <TableCell align="right">
                    {Math.ceil(
                      comercialQuantity(product.m2qty,props.desperdicio,props.m2Solicitados,product.prod.sup))}
                    {" " + product.prod.packaging}
                  </TableCell>
                  <TableCell align="right">
                    ${" "}
                    {
                      totalComercialPrice(product.m2qty,props.desperdicio,props.m2Solicitados,product.prod.sup,product.prod.priceud).toFixed(2)
                    }
                  </TableCell>
                </TableRow>
              ))}

<TableRow>
                <TableCell colSpan={4} />
                <TableCell>
                  <strong>TOTAL PESOS</strong>
                </TableCell>
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {totalPriceAlt(props.products, props.alternativeOption, props.desperdicio, props.m2Solicitados,obraEstimativa,qtyObraEstimativa)}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
                <TableCell colSpan={1} />
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {totalPriceComercialAlt(props.products, props.alternativeOption, props.desperdicio, props.m2Solicitados,obraEstimativa,qtyObraEstimativa)}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4} />
                <TableCell>
                  <strong>TOTAL PESOS/m2</strong>
                </TableCell>
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {(totalPriceAlt(props.products, props.alternativeOption, props.desperdicio, props.m2Solicitados,obraEstimativa,qtyObraEstimativa) / props.m2Solicitados).toFixed(2)}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
                <TableCell colSpan={1} />
                <TableCell align="right">
                  <span>
                    <strong>$</strong>
                  </span>{" "}
                  {(totalPriceComercialAlt(props.products, props.alternativeOption, props.desperdicio, props.m2Solicitados,obraEstimativa,qtyObraEstimativa)/ props.m2Solicitados).toFixed(2)}{" "}
                  <span>
                    <strong>+I.V.A</strong>
                  </span>
                </TableCell>
              </TableRow>

            </TableBody>
          </Table>
        </Paper>
        <TablePDF
            products={props.products}
            waste={props.desperdicio}
            m2={props.m2Solicitados}
            obraEstimativa={obraEstimativa}
            qtyObraEstimativa={qtyObraEstimativa}
            email={props.email}
            alternativeProducts={props.alternativeOption}
            templateSelected={props.templateSelected}
            alternativeDescription={props.alternativeDescription}
          />
      </div>
    </div>
  );
}
